/* eslint-disable no-console */
import {httpGet, httpPost, httpPut} from './http.service';
import {
    ModifyPresentationPrototypeRequest,
    PresentationPrototype,
    PresentationPrototypeItemDTO,
    PresentationPrototypeRequest,
    PresentationPrototypeType,
} from '../incase-domain/presentationPrototype';
import {SlideSize} from '../ui/pages/generator/types';

export const generatePresentationPrototype = (req: PresentationPrototypeRequest): Promise<PresentationPrototype> => {
    return httpPost(`editor/generator`, req).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const modifyPresentationPrototype = (req: ModifyPresentationPrototypeRequest): Promise<PresentationPrototype> => {
    return httpPost(`editor/generator/modify`, req).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const updatePresentationPrototype = (prototype: PresentationPrototype): Promise<PresentationPrototype> => {
    return httpPut(`editor/generator/update`, prototype).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const fetchPresentationPrototype = (): Promise<PresentationPrototype> => {
    return httpGet(`editor/generator`).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const fetchPresentationPrototypePromptHistory = (id: string): Promise<PresentationPrototypeItemDTO[]> => {
    return httpPost(`editor/generator/prompt-history`, {id}).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const revertPresentationPrototypeToPrompt = (id: string): Promise<PresentationPrototype> => {
    return httpPost(`editor/generator/revert-prompt`, {id}).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const organizePrototypeBySlides = (
    id: string,
    slideSize?: SlideSize,
    pages?: string[],
    content?: string
): Promise<PresentationPrototype> => {
    return httpPost(`editor/generator/organize-by-slides`, {
        id,
        ...(slideSize ? {slideSize} : {}),
        ...(pages ? {pages} : {}),
        ...(content ? {content} : {}),
    }).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};

export const createPresentationPrototype = (type?: PresentationPrototypeType): Promise<PresentationPrototype> => {
    return httpPost(`editor/generator/new`, type ? {type} : {}).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && [403, 429].includes(error.response.status)) {
            throw new Error(error.response.data.message);
        }
    });
};
